import React, { useContext, createContext } from 'react'
import { useExternalAuth } from './useExternalAuth'

const AuthContext = createContext<ReturnType<typeof useExternalAuth> | null>(null)

interface AuthProviderProps {
  children: React.ReactNode
  config: {
    authServerUrl: string
    currentAppName: string
  }
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children, config }) => {
  const auth = useExternalAuth(config)

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
